import type { DocumentStatus } from "./types";

/* ------------------------------------------------------------------ */
/* Badge status mapping                                                */
/* ------------------------------------------------------------------ */

export type BadgeStatus = "active" | "completed" | "overdue" | "draft";

export const statusToBadge: Record<DocumentStatus, BadgeStatus> = {
  final: "completed",
  draft: "draft",
  "under-review": "active",
  expired: "overdue",
};

export const documentStatusLabelKey = {
  final: "status.final",
  draft: "status.draft",
  "under-review": "status.underReview",
  expired: "status.expired",
} as const satisfies Record<
  DocumentStatus,
  "status.final" | "status.draft" | "status.underReview" | "status.expired"
>;

/* ------------------------------------------------------------------ */
/* Category styles                                                     */
/* ------------------------------------------------------------------ */

/**
 * Returns monochrome style for categories (no colors, icons only).
 */
export function getCategoryStyle(): { bg: string; text: string } {
  return {
    bg: "rgba(161,161,170,0.10)",
    text: "var(--color-secondary)",
  };
}

/* ------------------------------------------------------------------ */
/* Tag suggestions for upload                                          */
/* ------------------------------------------------------------------ */

export const TAG_SUGGESTIONS = [
  "Financial",
  "Legal",
  "Technical",
  "Compliance",
  "HR",
  "Operations",
  "SOX",
  "GDPR",
  "Security",
  "ISO 27001",
  "Risk",
  "CCPA",
  "Evidence",
  "Training",
  "Vendor",
  "Infrastructure",
];
